/* eslint-disable no-unused-vars */

export const imgDomain = 'https://academy-cdn-1316336521.cos.ap-guangzhou.myqcloud.com/';
export const urlDomain = 'https://academy-api.gymooit.cn'
// export const imgDomain = 'https://xmg-cdn.oss-cn-shenzhen.aliyuncs.com/';
